import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.string.includes.js";
import { defineStore } from 'pinia';
export var InviteOrganizerStep = /*#__PURE__*/function (InviteOrganizerStep) {
  InviteOrganizerStep[InviteOrganizerStep["InviteUser"] = 0] = "InviteUser";
  InviteOrganizerStep[InviteOrganizerStep["CreateOrganizer"] = 1] = "CreateOrganizer";
  InviteOrganizerStep[InviteOrganizerStep["SetupFees"] = 2] = "SetupFees";
  InviteOrganizerStep[InviteOrganizerStep["Finish"] = 3] = "Finish";
  return InviteOrganizerStep;
}({});
var useInviteOrganizerStoreDefinition = defineStore('inviteOrganizer', {
  state: function state() {
    return {
      validSteps: [],
      user: null,
      userNotFound: false,
      userDeleted: false,
      organizerData: null,
      currencies: [],
      feeType: null,
      feeData: null,
      cancelModal: false
    };
  },
  getters: {
    getSteps: function getSteps(state) {
      return state.validSteps;
    },
    getModal: function getModal(state) {
      return state.cancelModal;
    },
    getUser: function getUser(state) {
      return state.user;
    },
    getUserState: function getUserState(state) {
      return state.userNotFound;
    },
    getUserDeleted: function getUserDeleted(state) {
      return state.userDeleted;
    },
    getOrganizerData: function getOrganizerData(state) {
      return state.organizerData;
    },
    getCurrencies: function getCurrencies(state) {
      return state.currencies;
    },
    getFeeType: function getFeeType(state) {
      return state.feeType;
    },
    getFeeData: function getFeeData(state) {
      return state.feeData;
    }
  },
  actions: {
    addStepValid: function addStepValid(payload) {
      if (this.validSteps.includes(payload)) {
        return;
      }
      this.validSteps.push(payload);
    },
    removeStepValid: function removeStepValid(payload) {
      var index = this.validSteps.indexOf(payload);
      if (index > -1) {
        this.validSteps.splice(index, 1);
      }
    },
    setModal: function setModal(payload) {
      this.cancelModal = payload;
    },
    setUser: function setUser(payload) {
      this.user = payload;
    },
    setUserNotFound: function setUserNotFound(payload) {
      this.userNotFound = payload;
    },
    setUserDeleted: function setUserDeleted(payload) {
      this.userDeleted = payload;
    },
    setCurrencies: function setCurrencies(payload) {
      this.currencies = payload;
    },
    setOrganizerData: function setOrganizerData(payload) {
      this.organizerData = payload;
    },
    setFeeType: function setFeeType(payload) {
      this.feeType = payload;
    },
    setFeeData: function setFeeData(payload) {
      this.feeData = payload;
    },
    resetUserStatus: function resetUserStatus() {
      this.userNotFound = false;
      this.userDeleted = false;
    },
    clearUser: function clearUser() {
      this.user = null;
      this.validSteps = [];
    },
    clearUserState: function clearUserState() {
      this.userNotFound = false;
      this.userDeleted = false;
      this.validSteps = [];
      this.user = null;
      this.cancelModal = false;
      this.organizerData = null;
      this.feeType = null;
      this.feeData = null;
    }
  },
  persist: true
});

// VUE 2.7 WORKAROUND — see composables/usePinia.ts. Remove this wrapper at
// the Vue 3 flip and export useInviteOrganizerStoreDefinition directly as
// useInviteOrganizerStore instead.
export function useInviteOrganizerStore() {
  return useInviteOrganizerStoreDefinition(usePinia());
}